import { Reveal, Overline } from "./Reveal";

const ABOUT_IMG = "https://images.pexels.com/photos/36733407/pexels-photo-36733407.jpeg";

const chapters = [
  {
    n: "01",
    title: "Architecture & Product Engineering",
    body: "We start where it matters — designing resilient system architecture and engineering products built to scale from day one.",
  },
  {
    n: "02",
    title: "Deployment, Integration & Automation",
    body: "We connect complex enterprise ecosystems, automate critical workflows, and ship to production with confidence.",
  },
  {
    n: "03",
    title: "Managed Support & Evolution",
    body: "Our engagement doesn't end at launch. We operate, monitor, and continuously evolve your platforms as a long-term partner.",
  },
];

export const About = () => (
  <section id="about" className="relative z-10 bg-ink-950 py-24 md:py-32" data-testid="about-section">
    <div className="mx-auto max-w-7xl px-6 md:px-12">
      <div className="grid gap-16 lg:grid-cols-2 lg:gap-24">
        <div className="lg:sticky lg:top-32 lg:h-fit">
          <Reveal><Overline>About Team-X</Overline></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-6 font-display text-3xl font-bold leading-tight tracking-tighter text-white sm:text-4xl md:text-5xl">
              End-to-end technology partners for the intelligent enterprise.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 max-w-xl text-base leading-relaxed text-zinc-400 sm:text-lg">
              Team-X IT and Consulting Services provides complete technology solutions — spanning
              architecture, product engineering, deployment, integration, automation, and managed
              support. We help enterprises and service providers turn emerging technology into
              durable operational advantage.
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="mt-10 overflow-hidden rounded-2xl border border-white/10">
              <img
                src={ABOUT_IMG}
                alt="Enterprise engineering team collaborating"
                className="h-64 w-full object-cover grayscale transition-all duration-700 hover:grayscale-0 sm:h-80"
              />
            </div>
          </Reveal>
        </div>

        <div className="flex flex-col">
          {chapters.map((c, i) => (
            <Reveal
              key={c.n}
              delay={i * 0.08}
              className={`group border-t border-white/10 py-10 ${i === chapters.length - 1 ? "border-b" : ""}`}
            >
              <div className="flex items-start gap-6">
                <span className="font-display text-5xl font-black leading-none text-white/10 transition-colors duration-500 group-hover:text-brand/40 sm:text-6xl">
                  {c.n}
                </span>
                <div>
                  <h3 className="font-display text-2xl font-semibold tracking-tight text-white">
                    {c.title}
                  </h3>
                  <p className="mt-3 text-base leading-relaxed text-zinc-400">{c.body}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
